import { captureRecruitmentContext } from '~/utils/recruitmentContext'

export const state = () => ({
	invitations: []
})

export const mutations = {
	setInvitations(state, invitations) {
		state.invitations = invitations
	}
}

export const actions = {
	async fetch({ commit, rootState }, jobOfferId) {
		const isCurrentContext = captureRecruitmentContext(rootState)
		let response
		try {
			response = await this.$axios.$get(
				`/job-offer/${jobOfferId}/assessment-invitations`,
				{ __skipGlobalErrorToast: true }
			)
		} catch (error) {
			if (!isCurrentContext()) return []
			throw error
		}
		if (!isCurrentContext()) return []
		const invitations = response?.data || []
		commit('setInvitations', invitations)
		return invitations
	},

	async send({ commit, rootState }, { jobOfferId, emails, responsibility, resend = false }) {
		const isCurrentContext = captureRecruitmentContext(rootState)
		let response
		try {
			response = await this.$axios.$post(
				`/job-offer/${jobOfferId}/assessment-invitations`,
				{ emails, ...(responsibility ? { responsibility } : {}), ...(resend ? { resend: true } : {}) },
				{ __skipGlobalErrorToast: true }
			)
		} catch (error) {
			if (!isCurrentContext()) return null
			throw error
		}
		if (!isCurrentContext()) return null
		const invitations = response?.data || []
		if (response?.job_offer_access) {
			commit(
				'jobOffer/UPDATE_JOB_OFFER_ACCESS',
				response.job_offer_access,
				{ root: true }
			)
		}
		commit('setInvitations', invitations)
		return invitations
	}
}
